import React, { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../../../../../store/ducks/solicitacoesRetorno/actions';
import { Button, Card, Dropdown, List, Tag } from 'antd';
import CardSecMobile from '../CardSecMobile';

import { ButtonsStyle, RowLine, SpanBlock } from './styles';
import iconcoleta from '../../../../../../assets/img/coleta.svg';
import iconentrega from '../../../../../../assets/img/entrega.svg';
import ModalDetalhesVeiculo from '../../../../../../components/ModalDetalhesVeiculo';
import ModalDetalhesMotorista from '../Modal/ModalDetalhesMotorista';
import ModalCancelarPedido from '../Modal/ModalCancelarPedido';
import ModalEditarPedido from '../Modal/ModalEditarPedido';
import { PrinterOutlined, EllipsisOutlined } from '@ant-design/icons';
import { SKW_PREFIX } from '../../../../../../utils/constants';
import api from '../../../../../../service/api';
import saveAs from 'file-saver';
import { ApplicationState } from '../../../../../../store';

const CardMobile: React.FC<any> = ({
  props,
  loading,
  inscricaoAtiva,
  cddAtivo,
  filter,
  pagination,
}) => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const token = useSelector((state: ApplicationState) => state.auth.token);

  const paginationProps = {
    onChange: (pag: any) => {
      const resultado = {
        ...pagination,
        current: pag,
      };
      dispatch(
        loadRequest(
          filter,
          filter?.codParceiro ? [+filter.codParceiro] : inscricaoAtiva,
          cddAtivo?.codEmp,
          resultado
        )
      );
    },
    showSizeChanger: true,
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: pagination.total,
  };
  const getStatusName = (text: string) => {
    let name;
    let color;
    switch (text) {
      case 'AGU':
        color = 'orange';
        name = 'AGUARDANDO';
        break;
      case 'REC':
        color = 'red';
        name = 'RECUSADO';
        break;
      case 'AGE':
        color = 'blue';
        name = 'AGENDADO';
        break;
      case 'CHE':
        color = 'green';
        name = 'CHEGOU';
        break;
      case 'ENT':
        color = 'Limegreen';
        name = 'ENTROU';
        break;
      case 'FIM':
        color = 'gray';
        name = 'FIM DA OPERAÇÂO';
        break;
      default:
        color = 'green';
        break;
    }

    return name === '' ? (
      ''
    ) : (
      <Tag style={{ textTransform: 'uppercase' }} color={color}>
        {name}
      </Tag>
    );
  };
  const handlePdf = (value: any) => {
    api
      .get(
        `/call?serviceName=${SKW_PREFIX}imprimeAgendamento&token=${token}&agendamento=${value.codAgendamento}`,
        {
          responseType: 'arraybuffer',
        }
      )
      .then((res) => {
        const blob = new Blob([res.data], { type: 'application/pdf' });
        saveAs(blob, `AGENDAMENTO_${value.codAgendamento}.pdf`);
      });
  };

  return (
    <List
      grid={{ gutter: 16, column: 1 }}
      pagination={paginationProps}
      loading={loading}
      dataSource={props}
      renderItem={(item: any) => (
        <List.Item>
          <Card title={props.nuNota} style={{ textAlign: 'end' }}>
            <Dropdown
              overlay={
                // {(item.status === 'AGU' || item.status === 'REC' || item.status === 'AGE') && (
                <ButtonsStyle className="themeBackgroudButton">
                  <Button
                    onClick={() => handlePdf(item)}
                    className="primary themeButomAgendamento"
                    type="primary"
                    block
                    icon={<PrinterOutlined />}
                    style={{ display: 'block', width: '100%', border: '1px solid #DDD' }}
                  >
                    Imprimir
                  </Button>

                  <div className="primary">
                    <ModalEditarPedido record={item} />
                  </div>
                  <div className="primary">
                    <ModalCancelarPedido codAgendamento={item.codAgendamento} record={item} />
                  </div>
                </ButtonsStyle>
              }
            >
              <Button type="link" className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                <EllipsisOutlined style={{ fontSize: '30px', transform: 'rotate(90deg)' }} />
              </Button>
            </Dropdown>

            <RowLine>
              {item.tipoWms === 'EXP' ? (
                <img className="icontop" width="15px" src={iconentrega} alt="Saída" title="Saída" />
              ) : (
                <img
                  className="icontop"
                  width="15px"
                  src={iconcoleta}
                  alt="Entrada"
                  title="Entrada"
                />
              )}
            </RowLine>
            <RowLine>
              <p>
                <strong>Data/Hora</strong> <SpanBlock>{item.dhAgendamento}</SpanBlock>
              </p>
              <p>
                <strong>Centro distribuição</strong>{' '}
                <SpanBlock>{item.centroDistribuicao}</SpanBlock>
              </p>
              <p>
                <strong>Cliente</strong> <SpanBlock>{item.cliente}</SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Transportadora</strong>
                <SpanBlock>{item.transportadora}</SpanBlock>
              </p>

              <p>
                <strong>N° solicitação</strong>
                <SpanBlock>{item.codOrdemCarga}</SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Status</strong>
                <SpanBlock>{getStatusName(item.status)}</SpanBlock>
              </p>
              <p>
                <strong>Motorista</strong>
                <SpanBlock>
                  <ModalDetalhesMotorista motorista={item.detalheMotorista}>
                    {item.motorista}
                  </ModalDetalhesMotorista>
                </SpanBlock>
              </p>
              <p>
                <strong>Veículo</strong>
                <SpanBlock>
                  <ModalDetalhesVeiculo veiculo={item.detalheVeiculo}>
                    {item.placa}
                  </ModalDetalhesVeiculo>
                </SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Peso bruto</strong>
                <SpanBlock>{item.pesoBruto}</SpanBlock>
              </p>
              <p>
                <strong>Valor total</strong>
                <SpanBlock>{item.valor}</SpanBlock>
              </p>
            </RowLine>
            <CardSecMobile nuNota={item.nuNota} props={item} inscricaoAtiva={inscricaoAtiva} />
          </Card>
        </List.Item>
      )}
    />
  );
};
export default CardMobile;
